module.exports = __webpack_public_path__ + "static/media/cardIcon.496d169f.svg";